import { RadioGroup } from '@cian/ui-kit';
import * as React from 'react';

import styles from './MapType.css';
import { EMapTypes } from '../../../constants/map';

interface IMapTypeProps extends React.HTMLProps<HTMLDivElement> {
  mapType: EMapTypes;
  coordinates: {
    lat: number;
    lng: number;
  };
}

const OPTIONS = [
  { value: EMapTypes.satellite, label: 'Спутник' },
  { value: EMapTypes.map, label: 'Схема' },
];

export class MapType extends React.PureComponent<IMapTypeProps> {
  public render() {
    const { mapType, onChange } = this.props;

    return (
      <div className={styles['container']}>
        <RadioGroup options={OPTIONS} value={mapType} onChange={onChange} />
      </div>
    );
  }
}
